import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './HighlightTag.module.scss'

const SIZE_TO_CLASS = {
  md: '',
  sm: 'text-regular px-3 py-0',
}

const propTypes = {
  /**
   * content of the tag
   */
  children: PropTypes.node.isRequired,
  /**
   * Class to override default styles
   */
  className: PropTypes.string,
  /**
   * Size of the tag
   */
  size: PropTypes.oneOf(['md', 'sm']),
}

function HighlightTag(props) {
  const { children, className = '', size = 'md' } = props ?? {}

  return <span className={clsx(styles.base, SIZE_TO_CLASS[size], className)}>{children}</span>
}

HighlightTag.propTypes = propTypes

export default HighlightTag
